import {
  Component,
  OnInit
} from '@angular/core';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import {
  AlertService,
  AuthenticationService,
  UserService
} from '../../_services';
import { User } from '../../_models';

@Component({
    standalone: false,
  selector: 'multi-login',
  templateUrl: './multi-login.component.html',
  styleUrls: ['./multi-login.component.scss']
})
export class MultiLoginComponent implements OnInit {
  public users: User[];
  public rowGroupMetadata = {};
  public expanded = {};

  constructor(public route: ActivatedRoute,
              public router: Router,
              public userService: UserService,
              public authenticationService: AuthenticationService,
              public alertService: AlertService) {
  }

  public ngOnInit() {
    this.userService.getMultilogin().subscribe((u) => {
      this.users = u;
      this.updateRowGroupMetaData();
      this.users.forEach((s) => this.expanded[s.emailAddress] = true);
    });
  }

  public setMultilogin(id, tenantName, value) {
    this.userService.setMultilogin(id, tenantName, value).subscribe();
  }

  public updateRowGroupMetaData() {
    const data = this.users;
    const field = 'emailAddress';
    this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData[field];
        if (i === 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData[field];
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[brand].size++;
          } else {
            this.rowGroupMetadata[brand] = {index: i, size: 1};
          }
        }
      }
    }
  }
}
